import React from 'react';
import { Card, Row, Col, Button, Table } from 'react-bootstrap';
import { FaEuroSign, FaEdit, FaChartLine, FaTag, FaFileContract } from 'react-icons/fa'; // Added FaFileContract
import { MODE_FACTURACIO_OPTIONS, TYPE_OFERTA_OPTIONS } from '../../utils/constants/tarifas';
import { subtipoLabels } from '../../utils/ofertasUtils';

// Targeta de resum de la tarifa (accés, comercial, mode facturació, consums); usada a OfertaDetail i ContratoDetail.
const EconomicDataCard = ({ economicData, onEdit }) => {
    const resolveValue = (...values) => {
        for (const value of values) {
            if (value !== undefined && value !== null && value !== '') {
                return value;
            }
        }
        return null;
    };

    const isGasSector = economicData?.sector_type === 'gas';
    const modeFacturacio = isGasSector
        ? resolveValue(economicData?.gas_mode_facturacio, economicData?.mode_facturacio)
        : resolveValue(economicData?.mode_facturacio, economicData?.gas_mode_facturacio);
    const coeficientK = isGasSector
        ? resolveValue(economicData?.gas_coeficient_k, economicData?.coeficient_k)
        : resolveValue(economicData?.coeficient_k, economicData?.gas_coeficient_k);

    // Helper to get mode label
    const getModeLabel = (mode) => {
        if (!mode) return null;
        const option = MODE_FACTURACIO_OPTIONS.find(opt => opt.value === mode);
        return option ? option.label : mode;
    };

    // Helper to get type label
    const getTypeLabel = (type) => {
        if (!type) return null;

        const subtypeLabel = subtipoLabels[type];
        if (subtypeLabel) return subtypeLabel;

        const option = TYPE_OFERTA_OPTIONS.find(opt => opt.value === type);
        if (option) return option.label;

        return String(type)
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    return (
        <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden">
            <Card.Header className="bg-white border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <FaEuroSign className="me-2" />
                    Información de Tarifa
                </div>
                {onEdit && (
                    <Button
                        variant="link"
                        className="p-0"
                        onClick={onEdit}
                        title="Editar Tarifa"
                        aria-label="Editar información de tarifa"
                    >
                        <FaEdit size={18} />
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                <Row className="g-4">
                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaTag className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Tarifa Acceso</label>
                                <p className="detail-card-value text-dark">{economicData.tarifa || "No especificada"}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaFileContract className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Tarifa Comercial</label>
                                <p className="detail-card-value text-dark">{economicData.tarifa_comercial || <span className="text-muted fst-italic">No especificada</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaChartLine className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Tipo de Oferta</label>
                                <p className="detail-card-value text-dark">{getTypeLabel(economicData.tipo_oferta) || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaChartLine className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Modo Facturación</label>
                                <p className="detail-card-value text-dark">
                                    {getModeLabel(modeFacturacio) || <span className="text-muted fst-italic">No especificado</span>}
                                </p>
                            </div>
                        </div>
                    </Col>

                    {modeFacturacio === 'index' && (
                        <Col md={12}>
                            <div className="mt-2">
                                <label className="detail-card-label">Coeficientes</label>
                                <Table size="sm" bordered hover className="mb-0 text-center">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="fw-normal small text-muted">Coeficiente K</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="fw-bold text-dark">
                                                {coeficientK !== null && coeficientK !== undefined ? `${coeficientK} €/MWh` : <span className="text-muted fst-italic">No definido</span>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    )}

                    {economicData.consumos && (
                        <Col md={12}>
                            <div className="mt-2">
                                <label className="detail-card-label">Consumos Anuales</label>
                                <Table size="sm" bordered hover className="mb-0 text-center">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="fw-normal small text-muted">Calculado</th>
                                            <th className="fw-normal small text-muted">Previsto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="fw-bold text-dark">{economicData.consumos.calculado ? `${economicData.consumos.calculado} kWh` : '-'}</td>
                                            <td className="fw-bold text-dark">{economicData.consumos.previsto ? `${economicData.consumos.previsto} kWh` : '-'}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default EconomicDataCard;
